(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  const initBundleBuilder = (root) => {
    root.querySelectorAll('[data-bundle-builder]:not([data-bundle-initialized])').forEach((builder) => {
      builder.setAttribute('data-bundle-initialized', 'true');

      const cards = Array.from(builder.querySelectorAll('[data-bundle-card]'));
      const button = builder.querySelector('[data-bundle-submit]');
      const status = builder.querySelector('[data-bundle-status]');
      const error = builder.querySelector('[data-bundle-error]');
      const totals = builder.querySelector('[data-bundle-totals]');
      const subtotalPrice = builder.querySelector('[data-bundle-subtotal]');
      const discountedPrice = builder.querySelector('[data-bundle-discounted]');
      let isAdding = false;

      const stripHtml = (value) => {
        const element = document.createElement('span');
        element.innerHTML = value;
        return element.textContent || element.innerText || '';
      };

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (Number.isNaN(number) || number == null) {
          return '0';
        }

        const parts = (number / 100).toFixed(precision).split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        return parts[1] ? parts.join(decimal) : parts[0];
      };

      const formatMoney = (cents) => {
        const defaultMoneyFormat = '$' + '{' + '{amount}' + '}';
        const moneyFormat = builder.dataset.moneyFormat || defaultMoneyFormat;
        let formatted = '';

        if (window.themeVendor && window.themeVendor.themeCurrency && typeof window.themeVendor.themeCurrency.formatMoney === 'function') {
          formatted = window.themeVendor.themeCurrency.formatMoney(cents, moneyFormat);
        } else {
          const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          const match = moneyFormat.match(placeholderRegex);
          const formatType = match ? match[1] : 'amount';
          let value = '';

          if (formatType === 'amount_no_decimals') {
            value = formatWithDelimiters(cents, 0);
          } else if (formatType === 'amount_with_comma_separator') {
            value = formatWithDelimiters(cents, 2, '.', ',');
          } else if (formatType === 'amount_no_decimals_with_comma_separator') {
            value = formatWithDelimiters(cents, 0, '.', ',');
          } else {
            value = formatWithDelimiters(cents, 2);
          }

          formatted = moneyFormat.replace(placeholderRegex, value);
        }

        if (builder.dataset.currencyCodeEnable === 'true' && builder.dataset.currencyCode) {
          formatted = `${formatted} ${builder.dataset.currencyCode}`;
        }

        return stripHtml(formatted);
      };

      const getSelectedCards = () => cards.filter((card) => {
        const checkbox = card.querySelector('[data-bundle-checkbox]');
        return checkbox && checkbox.checked && !checkbox.disabled && card.dataset.variantId;
      });

      const getDiscountCode = (count) => {
        if (count >= 3) {
          return builder.dataset.discountCode3 || '';
        }

        if (count === 2) {
          return builder.dataset.discountCode2 || '';
        }

        return '';
      };

      const getDiscountedCents = (subtotalCents, count) => {
        if (count < 2) {
          return subtotalCents;
        }

        const discountType = count >= 3 ? builder.dataset.discountType3 : builder.dataset.discountType2;
        const rawValue = count >= 3 ? builder.dataset.discountValue3 : builder.dataset.discountValue2;
        const discountValue = Math.max(0, Number.parseFloat(rawValue || '0') || 0);
        let discountCents = 0;

        if (discountType === 'amount') {
          discountCents = Math.round(discountValue * 100);
        } else {
          discountCents = Math.round(subtotalCents * Math.min(discountValue, 100) / 100);
        }

        return Math.max(0, subtotalCents - discountCents);
      };

      const updateCardState = (card) => {
        const checkbox = card.querySelector('[data-bundle-checkbox]');
        card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked && !checkbox.disabled));
      };

      const closeCustomSelect = (customSelect) => {
        if (!customSelect) {
          return;
        }

        customSelect.classList.remove('is-open');
        const toggle = customSelect.querySelector('[data-bundle-select-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      };

      const closeCustomSelects = (except) => {
        builder.querySelectorAll('[data-bundle-custom-select].is-open').forEach((customSelect) => {
          if (customSelect !== except) {
            closeCustomSelect(customSelect);
          }
        });
      };

      const syncCustomSelect = (card, option) => {
        const customSelect = card.querySelector('[data-bundle-custom-select]');
        if (!customSelect || !option) {
          return;
        }

        const selectedValue = option.value || '';
        const selectText = customSelect.querySelector('[data-bundle-select-text]');
        const selectPrice = customSelect.querySelector('[data-bundle-select-price]');

        if (selectText) {
          selectText.textContent = option.dataset.title || option.textContent.trim();
        }

        if (selectPrice) {
          selectPrice.textContent = option.dataset.price || '';
        }

        customSelect.querySelectorAll('[data-bundle-option]').forEach((button) => {
          const isSelected = button.dataset.value === selectedValue;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
      };

      const syncCard = (card) => {
        const select = card.querySelector('[data-bundle-select]');
        const option = select ? select.options[select.selectedIndex] : null;
        const checkbox = card.querySelector('[data-bundle-checkbox]');
        const mediaLink = card.querySelector('[data-bundle-media-link]');
        const title = card.querySelector('[data-bundle-title]');
        const price = card.querySelector('[data-bundle-price]');
        const image = card.querySelector('[data-bundle-image]');
        const placeholder = card.querySelector('[data-bundle-placeholder]');

        if (!option) {
          return;
        }

        const available = option.dataset.available === 'true' && !option.disabled;
        card.dataset.variantId = option.value || '';
        card.dataset.priceCents = option.dataset.priceCents || '0';

        if (checkbox) {
          checkbox.disabled = !available;
          if (!available) {
            checkbox.checked = false;
          }
        }

        if (mediaLink && option.dataset.url) {
          mediaLink.href = option.dataset.url;
        }

        if (title) {
          title.textContent = option.dataset.title || '';
          if (option.dataset.url) {
            title.href = option.dataset.url;
          }
        }

        if (price) {
          price.textContent = option.dataset.price || '';
        }

        if (image && placeholder) {
          if (option.dataset.image) {
            image.src = option.dataset.image;
            image.alt = option.dataset.imageAlt || option.dataset.title || '';
            image.hidden = false;
            placeholder.hidden = true;
          } else {
            image.hidden = true;
            placeholder.hidden = false;
          }
        }

        syncCustomSelect(card, option);
        updateCardState(card);
      };

      const updateSummary = () => {
        if (isAdding) {
          return;
        }

        const selectedCards = getSelectedCards();
        const selectedCount = selectedCards.length;
        const code = getDiscountCode(selectedCount);
        const subtotalCents = selectedCards.reduce((sum, card) => sum + (Number.parseInt(card.dataset.priceCents || '0', 10) || 0), 0);
        const discountedCents = getDiscountedCents(subtotalCents, selectedCount);

        if (selectedCount < 2) {
          button.disabled = true;
          button.textContent = builder.dataset.selectTwo;
          status.textContent = builder.dataset.selectTwo;
          if (totals) {
            totals.hidden = true;
          }
          return;
        }

        button.disabled = false;
        button.textContent = selectedCount >= 3 ? builder.dataset.readyThree : builder.dataset.readyTwo;

        if (totals && subtotalPrice && discountedPrice) {
          totals.hidden = false;
          subtotalPrice.textContent = formatMoney(subtotalCents);
          discountedPrice.textContent = formatMoney(discountedCents);
        }

        if (code) {
          status.textContent = `${builder.dataset.codeLabel} ${code}`;
        } else {
          status.textContent = selectedCount >= 3 ? builder.dataset.offerThree : builder.dataset.offerTwo;
        }
      };

      cards.forEach((card) => {
        const select = card.querySelector('[data-bundle-select]');
        const checkbox = card.querySelector('[data-bundle-checkbox]');
        const customSelect = card.querySelector('[data-bundle-custom-select]');
        const toggle = card.querySelector('[data-bundle-select-toggle]');
        const optionButtons = Array.from(card.querySelectorAll('[data-bundle-option]'));

        if (select) {
          select.addEventListener('change', () => {
            if (error) {
              error.textContent = '';
            }
            syncCard(card);
            updateSummary();
          });
        }

        if (checkbox) {
          checkbox.addEventListener('change', () => {
            if (error) {
              error.textContent = '';
            }
            updateCardState(card);
            updateSummary();
          });
        }

        if (customSelect && toggle) {
          toggle.addEventListener('click', () => {
            const shouldOpen = !customSelect.classList.contains('is-open');
            closeCustomSelects(customSelect);
            customSelect.classList.toggle('is-open', shouldOpen);
            toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          });
        }

        optionButtons.forEach((optionButton) => {
          optionButton.addEventListener('click', () => {
            if (!select || optionButton.disabled || optionButton.classList.contains('is-disabled')) {
              return;
            }

            select.value = optionButton.dataset.value || '';
            select.dispatchEvent(new Event('change', { bubbles: true }));
            closeCustomSelect(customSelect);
          });
        });

        syncCard(card);
      });

      document.addEventListener('click', (event) => {
        if (builder.contains(event.target) && event.target.closest('[data-bundle-custom-select]')) {
          return;
        }

        closeCustomSelects();
      });

      builder.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeCustomSelects();
        }
      });

      builder.setAttribute('data-bundle-ready', 'true');
      button.addEventListener('click', () => {
        const selectedCards = getSelectedCards();

        if (selectedCards.length < 2 || isAdding) {
          updateSummary();
          return;
        }

        const quantities = selectedCards.reduce((items, card) => {
          const variantId = Number(card.dataset.variantId);
          if (variantId) {
            items.set(variantId, (items.get(variantId) || 0) + 1);
          }
          return items;
        }, new Map());

        const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
        const discountCode = getDiscountCode(selectedCards.length);
        const rootUrl = builder.dataset.rootUrl || '/';
        const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
        const cartUrl = builder.dataset.cartUrl || '/cart';

        isAdding = true;
        button.disabled = true;
        button.textContent = builder.dataset.adding;

        fetch(builder.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Cart add failed');
            }
            return response.json();
          })
          .then(() => {
            if (discountCode) {
              window.location.href = `${normalizedRootUrl}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartUrl)}`;
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(() => {
            isAdding = false;
            if (error) {
              error.textContent = builder.dataset.error;
            }
            updateSummary();
          });
      });

      updateSummary();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBundleBuilder(document));
  } else {
    initBundleBuilder(document);
  }

  document.addEventListener('shopify:section:load', (event) => initBundleBuilder(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
